



































































































































import UsersCreateDialog from '@/components/Agency/Users/UsersCreateDialog.vue'
import { getUsers, toggleActive } from '@/api/Users/users.api'
import { tableHandler } from '@/utils/mixins/tableHandler'
import { User } from '@/api/Auth/auth.interface'
import UsersFilter from '@/components/Agency/Users/UsersFilter.vue'
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import { message } from '@/store/modules/notifications'
import UserTreeviewDialog from '@/components/Agency/Users/UserTreeviewDialog.vue'
import ActionButton from '@/components/ActionButton.vue'
import { getProfile } from '@/api/Auth/auth.api'
import { transferBalanceMixin } from '@/utils/mixins/transferBalanceMixin'
import mixins from 'vue-typed-mixins'
import TransferBalance from '@/components/TransferBalance.vue'
import ConvertFunds from '@/components/ConvertFunds.vue'
import BalanceLabel from '@/components/BalanceLabel.vue'
import FlatCard from '~/components/FlatCard.vue'
import FlatTable from '~/components/FlatTable.vue'
import TextButton from '~/components/TextButton.vue'

export default mixins(transferBalanceMixin, tableHandler<User>()).extend({
  components: {
    appUsersCreateDialog: UsersCreateDialog,
    appUsersFilter: UsersFilter,
    appConfirmDialog: ConfirmDialog,
    appUserTreeviewDialog: UserTreeviewDialog,
    appActionButton: ActionButton,
    appTransferBalance: TransferBalance,
    ConvertFunds,
    BalanceLabel,
    FlatCard,
    FlatTable,
    TextButton,
  },
  data() {
    return {
      filterModel: false,
      confirmDialog: false,
      getter: getUsers,
      editedItem: null as null | User,
      changing: false,
      headers: [
        {
          text: this.$t('username'),
          value: 'username',
        },
        {
          text: this.$t('name'),
          value: 'first_name',
          sortable: false,
        },
        {
          text: this.$t('balance'),
          value: 'balance',
          sortable: false,
        },
        {
          text: this.$t('fund'),
          value: 'fund',
          sortable: false,
        },
        {
          text: this.$t('phone'),
          value: 'phone',
          sortable: false,
        },
        {
          text: 'Email',
          value: 'email',
          sortable: false,
        },
        {
          text: this.$t('services'),
          value: 'services',
          sortable: false,
        },
        {
          text: this.$t('active'),
          value: 'is_active',
          sortable: false,
        },
        {
          text: this.$t('actions'),
          value: 'actions',
          sortable: false,
        },
      ],
    }
  },
  computed: {
    isMobile(): boolean {
      return this.$vuetify.breakpoint.xs
    },
  },
  methods: {
    onChange(item: User) {
      this.editedItem = item
      this.confirmDialog = true
    },
    onDone(perform: boolean) {
      if (perform && this.editedItem) {
        try {
          this.changing = true
          toggleActive(this.editedItem)
          const payload: message = {
            text: this.$t('user.active-state-changed'),
            title: this.$t('user.modified'),
            color: 'success',
            icon: 'mdi-check-all',
            description: `${this.$t('user.user')} ${
              this.editedItem.username
            } ${this.$t('active-state-set-to')} ${
              this.editedItem.is_active
                ? this.$t('active')
                : this.$t('unactive')
            }`,
          }
          this.$store.commit('notifications/pushMessage', payload)
        } catch {
          this.editedItem.is_active = !this.editedItem.is_active
        } finally {
          this.changing = false
        }
      } else if (this.editedItem) {
        this.editedItem.is_active = !this.editedItem.is_active
      }
      this.editedItem = null
    },
    onRefresh() {
      this.table.refresh()
    },
  },
  created() {
    if (this.$store.getters.profile.role === 'ADMIN') {
      this.headers.splice(4, 0, {
        text: this.$t('role'),
        value: 'role',
        sortable: false,
      })
      this.headers.splice(2, 0, {
        text: this.$t('agency.agency'),
        value: 'agency_name',
        sortable: false,
      })
    }
  },
  mounted() {
    getProfile().then(response => {
      this.$store.commit('UPDATE_PROFILE', response.data)
    })
  },
})
